module.exports = __webpack_public_path__ + "static/img/logo1.1f7b9be7.png";